/* tslint:disable */
type TipoCalculoDividaEnum =
  'PREJUIZO' |
  'PREJUIZO_FIANCA' |
  'PERCENTUAL_DESCONTO' |
  'VALOR_DESCONTO' |
  'VALOR_HONORARIO_FIANCA' |
  'VALOR_VENDA_SALVADO' |
  'VALOR_DESCONTO_DESPESAS_CUSTAS' |
  'VALOR_DESPESAS_CUSTAS';
module TipoCalculoDividaEnum {
  export const PREJUIZO: TipoCalculoDividaEnum = 'PREJUIZO';
  export const PREJUIZO_FIANCA: TipoCalculoDividaEnum = 'PREJUIZO_FIANCA';
  export const PERCENTUAL_DESCONTO: TipoCalculoDividaEnum = 'PERCENTUAL_DESCONTO';
  export const VALOR_DESCONTO: TipoCalculoDividaEnum = 'VALOR_DESCONTO';
  export const VALOR_HONORARIO_FIANCA: TipoCalculoDividaEnum = 'VALOR_HONORARIO_FIANCA';
  export const VALOR_VENDA_SALVADO: TipoCalculoDividaEnum = 'VALOR_VENDA_SALVADO';
  export const VALOR_DESCONTO_DESPESAS_CUSTAS: TipoCalculoDividaEnum = 'VALOR_DESCONTO_DESPESAS_CUSTAS';
  export const VALOR_DESPESAS_CUSTAS: TipoCalculoDividaEnum = 'VALOR_DESPESAS_CUSTAS';
  export function values(): TipoCalculoDividaEnum[] {
    return [
      PREJUIZO,
      PREJUIZO_FIANCA,
      PERCENTUAL_DESCONTO,
      VALOR_DESCONTO,
      VALOR_HONORARIO_FIANCA,
      VALOR_VENDA_SALVADO,
      VALOR_DESCONTO_DESPESAS_CUSTAS,
      VALOR_DESPESAS_CUSTAS
    ];
  }
}

export { TipoCalculoDividaEnum }